import axios from 'axios';
import Store from '@/store';

export default class Interceptors {
  static Setup() :void {
    axios.interceptors.response.use((res) => {
      if (res.status === 401 && !res.config.url.endsWith('Logout')) {
        Store.commit('removeUserInfo');
        window.location.hash = '#/login?message=You are not authorized';
        return Promise.reject(res);
      } return Promise.resolve(res);
    }, (err) => {
      if (!(err.config && err.config.url.endsWith('token')) && (err.response.status === 401 || err.status === 401)) {
        if (err.response.data && err.response.data.m_Item1 === true) {
          window.location.hash = `#/error/${err.response.data.m_Item2}/code/403`;
        } else {
          Store.commit('removeUserInfo');
          window.location.hash = '#/login?message=Session has been expired';
        }
      }
      return Promise.reject(err);
    });
  }
}
